import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "اطلاعیه کوکی‌ها",
    description:
      "ما از کوکی‌های ضروری استفاده می‌کنیم تا این وب‌سایت به درستی کار کند. ما همچنین از کوکی‌های اختیاری ردیابی استفاده می‌کنیم تا بدانیم شما چگونه با وب‌سایت ما تعامل می‌کنید. این کوکی‌های اختیاری تنها با رضایت شما فعال می‌شوند.",
    acceptAllBtn: "پذیرفتن همه",
    acceptNecessaryBtn: "رد کردن همه",
    showPreferencesBtn: "مدیریت ترجیحات فردی",
  },
  preferencesModal: {
    title: "مدیریت ترجیحات کوکی",
    acceptAllBtn: "پذیرفتن همه",
    acceptNecessaryBtn: "رد کردن همه",
    savePreferencesBtn: "پذیرفتن انتخاب فعلی",
    closeIconLabel: "بستن پنجره",
    sections: [
      {
        title: "استفاده از کوکی",
        description:
          "ما از کوکی‌ها برای پشتیبانی از عملکردهای اساسی این وب‌سایت و بهبود تجربه مرور شما استفاده می‌کنیم.",
      },
      {
        title: "کوکی‌های کاملاً ضروری",
        description:
          "این کوکی‌ها برای عملکرد صحیح وب‌سایت ضروری هستند، مثلاً برای احراز هویت کاربر.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "نام",
            domain: "سرویس",
            description: "توضیحات",
            expiration: "انقضا",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکی تنظیم‌شده توسط پلتفرم دیجیتال برای احراز هویت کاربر.",
              expiration: "نشست",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "کوکی تنظیم‌شده توسط پلتفرم دیجیتال برای احراز هویت کاربر",
              expiration: "نشست",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "این کوکی برای تمایز بین انسان و ربات استفاده می‌شود تا وب‌سایت را در برابر سوءاستفاده خودکار محافظت کند. هیچ داده شخصی جمع‌آوری نمی‌شود.",
              expiration: "30 دقیقه",
            },
          ],
        },
      },
      {
        title: "تحلیل‌ها",
        description:
          "کوکی‌های استفاده‌شده برای تحلیل به جمع‌آوری داده‌ها کمک می‌کنند که به سرویس‌ها اجازه می‌دهند درک کنند کاربران چگونه با یک سرویس خاص تعامل می‌کنند. این بینش‌ها به بهبود محتوا و ایجاد قابلیت‌های بهتر برای ارتقای تجربه کاربر کمک می‌کند.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "نام",
            domain: "سرویس",
            description: "توضیحات",
            expiration: "انقضا",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکی تنظیم‌شده توسط <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "پس از 12 روز منقضی می‌شود",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکی تنظیم‌شده توسط <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "نشست",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "فعال‌سازی ذخیره‌سازی مرتبط با تحلیل‌ها، مانند مدت زمان بازدید.";

export { translation, servicesLabel };
